// extracted by mini-css-extract-plugin
module.exports = {"imageElement":"image-modal_component_imageElement__GpYu9","imageModal":"image-modal_component_imageModal__kflJV"};